import { BASE_URL } from "../../helpers/config";
import authorizedAxios from "../../helpers/authorizedAxios";
import { showToast } from "../../utils/helpers/ShowToast";
export const SET_SATUAN_KERJAS = "SET_SATUAN_KERJAS";
export const SET_SATUAN_KERJA = "SET_SATUAN_KERJA";
export const SET_SATUAN_KERJAS_LOADING = "SET_SATUAN_KERJAS_LOADING";
export const SET_SATUAN_KERJAS_ERROR = "SET_SATUAN_KERJAS_ERROR";

export const fetchSatuanKerjas = (limit = 1000, page = 1, _idMadrasah = null, _status = null) => {
  return async (dispatch) => {
    dispatch({ type: SET_SATUAN_KERJAS_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/satuan-kerja?limit=" + limit + "&page=" + page);

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_SATUAN_KERJAS,
          data: response?.data?.data
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_SATUAN_KERJAS_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil data."
      });
    } finally {
      dispatch({ type: SET_SATUAN_KERJAS_LOADING, status: false });
    }
  };
};

export const getSatuanKerjaById = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_SATUAN_KERJAS_LOADING, status: true });

    try {
      const response = await authorizedAxios.get(`/satuan-kerja/${id}`);

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_SATUAN_KERJA,
          data: response.data
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_SATUAN_KERJAS_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil data."
      });
    } finally {
      dispatch({ type: SET_SATUAN_KERJAS_LOADING, status: false });
    }
  };
};

export const addSatuanKerja = (data) => {
  return async (dispatch) => {
    dispatch({ type: SET_SATUAN_KERJAS_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.post(`${BASE_URL}/satuan-kerja`, data), {
        loading: "Menyimpan data...",
        success: "Data SATUAN_KERJA berhasil ditambahkan!",
        error: (err) => err?.response?.data?.message || "Gagal menyimpan data!"
      });
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchSatuanKerjas());
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_SATUAN_KERJAS_ERROR,
        error: error?.message || "Terjadi kesalahan."
      });
    } finally {
      dispatch({ type: SET_SATUAN_KERJAS_LOADING, status: false });
    }
  };
};

export const updateSatuanKerja = (id, data) => {
  return async (dispatch) => {
    dispatch({ type: SET_SATUAN_KERJAS_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.put(`${BASE_URL}/satuan-kerja/${id}`, data), {
        loading: "Mengupdate data...",
        success: "Data SATUAN_KERJA berhasil diupdate!",
        error: (err) => err?.response?.data?.message || "Gagal mengupdate data!"
      });
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchSatuanKerjas());
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_SATUAN_KERJAS_ERROR,
        error: error?.message || "Terjadi kesalahan."
      });
    } finally {
      dispatch({ type: SET_SATUAN_KERJAS_LOADING, status: false });
    }
  };
};

export const deleteSatuanKerja = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_SATUAN_KERJAS_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.delete(`${BASE_URL}/satuan-kerja/${id}`), {
        loading: "Menghapus data...",
        success: "Data SATUAN_KERJA berhasil dihapus!",
        error: (err) => err?.response?.data?.message || "Gagal menghapus data!"
      });
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchSatuanKerjas());
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_SATUAN_KERJAS_ERROR,
        error: error?.message || "Terjadi kesalahan."
      });
    } finally {
      dispatch({ type: SET_SATUAN_KERJAS_LOADING, status: false });
    }
  };
};
